import { environment } from '@env/environment';

export const DOOD_API = `${environment.api.dood.url}/api`;

export const DOOD_URL = `${environment.api.dood.url}`;
